/**************************************************************************************************
 *
 *  This is the main container for all project_type related views: ProjectType Detail (hierarch), ProjectType
 *  Edit/Creation, Build Edit/Creation, Task Detail, Field Task Detail
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import dataModel from '../../../../models/DataModel';
import Animate from '../../../../components/Animate';

import './ProjectTypeAddCard.scss';
import Input from '../../../../components/Input';

// Change ProjectTypeAddCard to the appropriate name
class ProjectTypeAddCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { project_typeName: '' };
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.inputField) {
      this.inputField.focus();
    }
  }

  handleAddProjectType() {
    let exist =  this.handleIfProjectTypeAlreadyExists(this.state.project_typeName);
    if(!exist){
      let validated = this.handleValidation(this.state.project_typeName);
      if (validated) {
        let self = this;
        dataModel.projectTypesDAO.createProjectType({ name: this.state.project_typeName, company: this.props.selectedCompany }).then(result=>{
          this.handleCancel();
          if(self.props.handleProjectTypeAdd){
            self.props.handleProjectTypeAdd(result);
          }
          self.handleCloseAnimation();
          this.props.history.push('/project-types/' + result.id);
        });
      }
      else {
        this.props.dataModel.displayInfoErrorMessage(this.textMap.ProjectTypeTypeNameRequired, 4000, 2);
      }
    }else{ 
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: this.textMap.projectTypeWithNameAlreadyExists,
        height: 170,
        width: 300,
        okButtonText: this.textMap.okButtonText,
        oneButton: true,
      });
    }
    this.handleCloseAnimation();
  }
  
  handleIfProjectTypeAlreadyExists(string){
    let allProjectTypes = this.props.allActualProjecTypes;
    return allProjectTypes.find(x=>{return x.name.toUpperCase() == string.toUpperCase();});
  }

  handleCancel() {
    this.setState({ cancelAdd: true });
  }

  handleCloseAnimation() {
    if (this.props.closeAddCard) {
      this.props.closeAddCard();
    }
  }

  handleChange(e) {
    this.setState({ project_typeName: e.target.value });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleAddProjectType();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  }

  handleValidation(string){
    let pass = false;
    if (string && string.length > 0 && string.trim() != ''){
      pass = true;
    }
    return pass;
  }

  render() {
    let style = {
      width: 200,
    };

    return (

      // Replace with the appropriate HTML
      <div className={'project_type-add-card'} id={this.props.id} style={style}>
        <Animate key="animate-card-in" component_id={this.props.id} duration={250} property={{
          height: {
            startVal: 0,
            endVal: 40,
          },
        }} onUnmount={false} /> 
        {this.state.cancelAdd && (
          <Animate key="animate-card-out" component_id={this.props.id} duration={250} property={{
            height: {
              startVal: 50,
              endVal: 40,
            },
          }} onUnmount={false} completionCallback={this.handleCloseAnimation} /> 
        )}
        <div className="add-project_type-box">
          <Input className="project_type-input" value={this.state.project_typeName} onChange={this.handleChange}
            placeholder={this.textMap.enterNewProjectTypeName} onKeyDown={this.handleKeyDown} ref={(element) => {
              this.inputField = element;
            }}/>
        </div>
        <div className='add-project-save' onClick={this.handleAddProjectType} />
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};
export default withRouter(connect(mapStateToProps)(ProjectTypeAddCard));



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeAddCard/index.js